module.exports = __webpack_public_path__ + "static/media/Zebstrika_gaussian2.1909edef.png";